import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_PARENT",
    applicationRights: [],
    title: 'Innstillinger',
    text: 'Innstillinger',
    icon: 'gear',
    showOnDashboardByDefault: false,
    sequenceNo: 18000,
    routes: Routes,
})
